import { render, staticRenderFns } from "./MobileNote.vue?vue&type=template&id=20a537d4&scoped=true&"
import script from "./MobileNote.vue?vue&type=script&lang=js&"
export * from "./MobileNote.vue?vue&type=script&lang=js&"
import style0 from "./MobileNote.vue?vue&type=style&index=0&id=20a537d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a537d4",
  null
  
)

export default component.exports